import { TimelineStatus } from './timeline-status';

export class TimelineDetail {
  status: TimelineStatus;
  description: string;
  description1: string;
  description2: string;
}
